import React, { useEffect, useState } from "react";
import ParticlesComponent from "./particles";

const Footer = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  const handleScroll = () => {
    if (window.scrollY >= 200) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer">
        <div className="footer__social">
          <a
            href="https://stackoverflow.com/users/15583300/chitraarasu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="footer__icon fa fa-stack-overflow"></i>
          </a>
          <a
            href="https://kchitraarasu.wordpress.com/blog/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="footer__icon fa fa-wordpress"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/chitraarasu-k/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="footer__icon fa fa-linkedin"></i>
          </a>
          <a
            href="https://www.instagram.com/chitraarasu.k/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="footer__icon fa fa-instagram"></i>
          </a>
          <a
            href="https://github.com/chitraarasu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="footer__icon fa fa-github"></i>
          </a>
          <a
            href="https://twitter.com/chitraarasu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="footer__icon fa fa-twitter"></i>
          </a>
        </div>
        <p>&#169; Copyright 2021-{currentYear}. Developed by Chitraarasu</p>
      </div>
      {/* <div id="particles-js" className="part"></div> */}
      <ParticlesComponent id="particles-js" />
      {showBackToTop ? (
        <a href="#Home">
          <div id="backtotop" title="Back to Top" className="adding">
            <i className="fa fa-angle-double-up"></i>
          </div>
        </a>
      ) : (
        <></>
      )}
    </footer>
  );
};

export default Footer;
